import React, { useState, useEffect } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import AuctionItems from "./AuctionItems";
import Productforsale from "./Productforsale";
import RentalProducts from "./RentalProducts";
import MergersAcquisitions from "./MergersAcquisitions";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import ActiveBXPListing from "./ActiveBXPListing";

export default function AllActiveOrders({ postcounts }) {
  const path = "Assets/scss/myorders.module.scss";
  const [activeTab, setActiveTab] = useState("AAuctionitems");
  const { urlstate, setReceivedOrderActiveroute } = useRouteBaseStateContext();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setReceivedOrderActiveroute(tab);
  };

  useEffect(() => {
    if (urlstate?.receivedorderrouteactive) {
      setActiveTab(urlstate?.receivedorderrouteactive || "AAuctionitems");
    } else {
      setActiveTab("AAuctionitems");
    }
  }, [urlstate, urlstate?.receivedorderrouteactive]);

  const prc =
    (Number(postcounts?.active_orders?.bxp) || 0) +
    (Number(postcounts?.order_request?.sale) || 0) +
    (Number(postcounts?.order_request?.rental) || 0);

  const rhc =
    (Number(postcounts?.order_request?.bxp_history) || 0) +
    (Number(postcounts?.order_request?.sale_history) || 0) +
    (Number(postcounts?.order_request?.rental_history) || 0);

  return (
    <div className="order-tabs">
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <a
            className={`nav-link ${
              activeTab == "ActiveBXPListing" ? "active" : ""
            }`}
            onClick={() => handleTabChange("ActiveBXPListing")}
          >
            One Time Services (OTS) ({postcounts?.bxp || 0})
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${
              activeTab == "AProductforsale" ? "active" : ""
            }`}
            onClick={() => handleTabChange("AProductforsale")}
          >
            Buy & Sell with Market (BSM) ({postcounts?.sale || 0})
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${
              activeTab == "ARentalproducts" ? "active" : ""
            }`}
            onClick={() => handleTabChange("ARentalproducts")}
          >
            Turn Assets to Income (TAI) ({postcounts?.rental || 0})
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${
              activeTab == "AAuctionitems" ? "active" : ""
            }`}
            onClick={() => handleTabChange("AAuctionitems")}
          >
            Buy & Sell with Auction (BSA) ({postcounts?.auction || 0})
          </a>
        </li>

        <li className="nav-item">
          <a
            className={`nav-link ${
              activeTab == "AMergersAcquisitions" ? "active" : ""
            }`}
            onClick={() => handleTabChange("AMergersAcquisitions")}
          >
            Merger & Acquisition Services (MAS) ({postcounts?.mergers || 0})
          </a>
        </li>
      </ul>
      <div className="tab-content">
        {activeTab == "ActiveBXPListing" && <ActiveBXPListing />}
        {activeTab == "AProductforsale" && <Productforsale />}
        {activeTab == "ARentalproducts" && <RentalProducts />}
        {activeTab == "AAuctionitems" && <AuctionItems />}
        {activeTab == "AMergersAcquisitions" && <MergersAcquisitions />}
      </div>
    </div>
  );
}
